import styled from "styled-components";
import { Checkbox } from "@ddm-design-system/checkbox";

export const StyledCheckbox = styled(Checkbox)``;

export const StyledItemText = styled.span``;
